import { get_token } from "@/router";

export default {
  name: 'Card',
  props: {
    task: Object,
    bucket: Object
  },
data() {
  return ({
    priority_statuses:[],
    task_statuses:[],
    localTaskStatusId: this.task.status_id,      // or whatever your task object uses
    localPriorityStatusId: this.task.priority_id,
    localStartDate: this.task.start_date,
    localDueDate: this.task.due_date,
    description: this.task.description || '',
    selected_task: null, // For modal
    showModal: false,
    showAssignDropdown: false,
    assignmenu:false,
    members: [],


  });
},
 watch: {
    // If the modal can be opened for different tasks, watch for changes
    'task.description'(newVal) {
      this.description = newVal || '';
    }
  },
  mounted(){
  this.fetchPortalMembers();
    document.addEventListener('click', this.handleClickOutside);

},
beforeUnmount() {
  document.removeEventListener('click', this.handleClickOutside);
},

  methods:{
    getToken() {
        return get_token();
        },
 open_task_modal(task, bucket) {
    this.$emit('open-task-modal', task, bucket);
  },
 fetchPortalMembers() {
    this.members = [];

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
      method: "GET",
      data: { portal_id:this.$route.params.portal_id },
      headers: {
        "Authorization": `Token ${this.getToken()}`,
        "Content-Type": "application/json"
      },
      success: (response) => {
        if (response.status === "success") {
          this.members = response.data.members;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
      error: (xhr) => {
        console.error("Error fetching portal members:", xhr);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  },
    toggleAssignDropdown() {
    this.showAssignDropdown = !this.showAssignDropdown;
    if (this.$refs.assignmenu) {
      this.$refs.assignmenu.classList.remove('show');
    }
  },
 getInitials(name) {
  if (!name || typeof name !== 'string') return '??'; // fallback
  const parts = name.trim().split(' ');
  return parts.map(p => p[0]).join('').toUpperCase().substring(0, 2);
},
  assignUser(member_id, task_id) {
    this.assignmenu = false; // Close dropdown after selection
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/assign_users_to_task/`,
      method: "POST",
      data: JSON.stringify({ task_id: task_id, assigned_ids: [member_id] }),
      headers: {
        "Authorization": `Token ${this.getToken()}`,
        "Content-Type": "application/json"
      },
      success: (response) => {
        if (response.status === "success") {
          this.showAssignDropdown = false;
           this.assignmenu = false;
          this.$emit('task-updated', response.data);
        }
      },
      error: (xhr) => {
        console.error("Error fetching portal members:", xhr);
      },
      complete: () => {
        this.isLoading = false;
      }
    });

  },
   handleClickOutside(event) {
    const dropdown = this.$refs.assignDropdown;
    if (dropdown && !dropdown.contains(event.target)) {
      this.showAssignDropdown = false;
    }
  },
  delete_task(task_id){
    $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_task/`,
          method: "POST",
          data: JSON.stringify({ task_id: task_id }),
          headers: {
            "Authorization": `Token ${this.getToken()}`,
            "Content-Type": "application/json"
          },
          success: (response) => {
            if (response.status === "success") {
              this.$emit('task-deleted', task_id);
            }
          },
          error: (xhr) => {
            console.error("Error fetching portal members:", xhr);
          },
          complete: () => {
            this.isLoading = false;
          }
        });
  }

  }
};